import { useEffect, useRef } from 'react'

const useGoogleMapImage = (
  lat: number,
  lng: number,
  options?: google.maps.MapOptions,
) => {
  const mapRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!mapRef.current || !google) return

    const position = { lat, lng }

    const map = new google.maps.Map(mapRef.current, {
      center: position, //  center explicitly
      zoom: 18,
      mapTypeId: 'satellite',

      // lock interaction
      disableDefaultUI: true,
      keyboardShortcuts: false,
      zoomControl: false,
      gestureHandling: 'none',
      clickableIcons: false,
      draggable: false,
      scrollwheel: false,
      disableDoubleClickZoom: true,
      ...(options || {}),
    })

    new google.maps.Marker({
      position,
      map,
    })
  }, [lat, lng, options])

  return mapRef
}

export default useGoogleMapImage
